import React from 'react';

interface Props {
    showLastUnitsMsg?: boolean;
    showStock?: boolean;
    lastUnitsMsg?: string;
    availableUnits: number;
    requiredQuantity: number;
    insufficientUnitsMsg: string;
}

export const ProductAvailabilityUI = (props: Props) => {
    const {
        showLastUnitsMsg,
        showStock,
        lastUnitsMsg,
        availableUnits,
        requiredQuantity,
        insufficientUnitsMsg
    } = props;

    // Rojo para mensajes de problema (sin stock / stock insuficiente): tiene que verse a la vista
    const alertTextStyle = { color: "#dc3545" };
    // Naranja para "últimas unidades": aviso, no error (el text-info cian apenas se leía)
    const warningTextStyle = { color: "#fd7e14" };

    return (
        <>
            {
                (() => {
                    let result;
                    if (showLastUnitsMsg === true) {
                        result = (
                            <small style={warningTextStyle}>
                                {lastUnitsMsg || 'Últimas unidades disponibles'}
                            </small>
                        );
                    } else if (availableUnits <= 0) {
                        if (!!insufficientUnitsMsg) {
                            result = (
                                <small style={alertTextStyle}>{insufficientUnitsMsg}</small>
                            );
                        } else {
                            result = (
                                <small style={alertTextStyle}>Disponible próximamente</small>
                            );
                        }
                    } else if (showStock === false && (!requiredQuantity || (requiredQuantity <= availableUnits))) {
                        result = (
                            <small className="text-primary">Producto disponible</small>
                        );
                    } else if (showStock === false || (requiredQuantity > availableUnits)) {
                        if (!!insufficientUnitsMsg) {
                            result = (
                                <small style={alertTextStyle}>{insufficientUnitsMsg}</small>
                            );
                        } else {
                            result = (
                                <small style={alertTextStyle}>Stock insuficiente.</small>
                            );
                        }
                    } else {
                        result = (
                            <small className="text-primary">{availableUnits} unidades disponibles</small>
                        );
                    }
                    return result;
                })()
            }
        </>
    );
};
